/**
 * Drop-target tracking shared by the two views that drag cards: OpsBoard and OpsOperatory (Practice Ops, plan §6).
 *
 * Sortable's `move` callback tells us which list is under the dragged card; the views turn that into the teal "drop here"
 * state (hoverCol) and the amber "room in use" state, and tell the page when a card is in the air so it can hold back store
 * updates (window.__isDragging, set by the page on `drag-start` / released on `drag-end`).
 *
 *   hoverCol   the target under the dragged card ('checkin' | 'checkout' | an OperatoryNum, as a string), or null
 *   dragFrom   the list the dragged card came from, so its own room never reads as "in use" while it is being dragged
 *   canMove    the page's `onMove` hook, asked while a card is dragged over a target. It can only veto; the page never does
 *              (plan behaviour call 2: no Ready gate).
 *
 * Emits drag-start(evt) / drag-end(evt). The decision about what a drop MEANS is not here — it is moves.js planMove.
 */
export default {
  props: {
    canMove: { type: Function, default: () => true },
  },

  data() {
    return {
      hoverCol: null,
      dragFrom: null,
    };
  },

  methods: {
    onDragStart(evt) {
      const from = evt && evt.from && typeof evt.from.getAttribute === 'function' ? evt.from.getAttribute('data-col') : null;
      this.dragFrom = from;
      this.$emit('drag-start', evt);
    },

    onDragEnd(evt) {
      this.hoverCol = null;
      this.dragFrom = null;
      this.$emit('drag-end', evt);
    },

    /** Sortable's move callback: note the target under the pointer, then ask the page (it never vetoes). */
    handleMove(evt) {
      const to = evt && evt.to && typeof evt.to.getAttribute === 'function' ? evt.to.getAttribute('data-col') : null;
      if (to !== this.hoverCol) this.hoverCol = to;
      return this.canMove(evt) !== false;
    },
  },
};
